import img1 from "../assets/s1.jpg";
import img2 from "../assets/s2.jpg";
import img3 from "../assets/s3.jpg";
import img4 from "../assets/s4.jpg";

function SchoolGallery() {
  return (
    <div className="school-gallery">

      <h2>Fun Moments at School 🎨</h2>

      <div className="school-grid">
        <img src={img1} alt="" />
        <img src={img2} alt="" />
        <img src={img3} alt="" />
        <img src={img4} alt="" />
      </div>

    </div>
  );
}

export default SchoolGallery;